export const shellSurfaceSx = {
  bgcolor: 'background.body',
  color: 'text.primary',
};

export const appShellViewportSx = {
  ...shellSurfaceSx,
  height: '100vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

export const basePageMainSx = {
  ...shellSurfaceSx,
  flexGrow: 1,
  p: { lg: 3, xs: 0 },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: '100%',
  minHeight: 0,
};
